import React from "react";

const PV = {
  sun:       { grad: "radial-gradient(circle at 30% 30%, #fef3c7, #ffd23f 50%, #b45309)", ring: "rgba(255,210,63,0.5)" },
  earth:     { grad: "radial-gradient(circle at 30% 30%, #93c5fd, #3db5ff 55%, #1e3a8a)", ring: "rgba(61,181,255,0.5)" },
  ice:       { grad: "radial-gradient(circle at 30% 30%, #ffffff, #e0f2fe 50%, #38bdf8)", ring: "rgba(56,189,248,0.5)" },
  jungle:    { grad: "radial-gradient(circle at 30% 30%, #bbf7d0, #22a651 55%, #14532d)", ring: "rgba(34,166,81,0.5)" },
  blackhole: { grad: "radial-gradient(circle at 50% 50%, #0e1230 25%, #7c3aed 70%, #0e1230)", ring: "rgba(124,58,237,0.6)" },
  moon:      { grad: "radial-gradient(circle at 30% 30%, #fafafa, #d4d4d8 60%, #71717a)", ring: "rgba(212,212,216,0.5)" },
  mars:      { grad: "radial-gradient(circle at 30% 30%, #fecaca, #e8302a 55%, #7f1d1d)", ring: "rgba(232,48,42,0.5)" },
  nebula:    { grad: "radial-gradient(circle at 35% 30%, #fbcfe8, #ff5da3 45%, #6366f1 80%, #1e1b4b)", ring: "rgba(255,93,163,0.5)" },
};

export default function GenrePlanetSelector({ genres, value, onChange }) {
  return (
    <div className="grid grid-cols-4 gap-2" data-testid="planet-selector">
      {genres.map((g) => {
        const v = PV[g.key] || PV.earth;
        const sel = value === g.key;
        return (
          <button key={g.key} type="button" onClick={() => onChange(g.key)} data-testid={`planet-${g.key}`} className="group relative flex flex-col items-center gap-1.5 p-2 rounded-2xl transition-all"
            style={{ background: sel ? "#fff" : "transparent", border: sel ? "2px solid var(--ink)" : "2px solid transparent", boxShadow: sel ? "3px 3px 0 0 var(--ink)" : "none" }}>
            <div className="relative w-12 h-12 sm:w-14 sm:h-14 rounded-full transition-transform group-hover:scale-110 animate-float"
              style={{ background: v.grad, boxShadow: `0 0 18px ${v.ring}, inset -4px -4px 8px rgba(0,0,0,0.25)`, animationDelay: `${Math.random() * 4}s`, border: "2px solid var(--ink)" }}>
              {sel && <div className="absolute -inset-1.5 rounded-full border-2 border-dashed animate-spin-slow" style={{ borderColor: "var(--ink)" }} />}
            </div>
            <div className="text-center">
              <div className="text-[0.7rem] font-bold leading-tight text-[var(--ink)]">{g.name}</div>
              <div className="text-[0.6rem] font-mono text-[var(--ink-soft)]">{g.mult}× boost</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
